import { useSlots as u, openBlock as f, createBlock as h, resolveDynamicComponent as _, h as s, cloneVNode as g } from "vue";
import t from "../../constants/screen.js";
const v = /* @__PURE__ */ Object.assign({
  name: "DsScreenWrapper"
}, {
  __name: "screen-wrapper",
  props: {
    ready: {
      type: Boolean,
      default: !1
    }
  },
  setup(l) {
    const m = (e) => {
      switch (e) {
        case "small":
          return "ds-md-hidden";
        case "medium":
          return "ds-hidden ds-md-hidden--false ds-lg-hidden";
        case "large":
          return "ds-hidden ds-lg-hidden--false ";
        default:
          return "";
      }
    }, i = l, r = u(), p = () => {
      var d, o;
      const e = (o = (d = r.default) == null ? void 0 : d.call(r)) == null ? void 0 : o[0];
      if (i.ready)
        return s("div", [e]);
      const a = [t.small.name, t.medium.name, t.large.name].map((c) => {
        const n = g(e, {});
        return n != null && n.props && (n.props.screen = c), s("div", { class: m(c) }, [n]);
      });
      return s("div", a);
    };
    return (e, a) => (f(), h(_(p)));
  }
}), B = v;
export {
  B as default
};
